<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26 10H42M26 24H42M26 38H42M6 34L10 38L18 30M6 14L10 18L18 10"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'OptionIcon',
    props: {
        size: { type: [Number, String], default: 24 },
        color: { type: String, default: 'currentColor' },
    },
}
</script>
